import { requestDocumentSignature } from '@/api/Company';
import { Documents } from '@/types/company';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

export const useRequestDocumentSignature = () =>
  useMutation<AxiosResponse, AxiosError, Documents.RequestSignaturePayload>({
    mutationKey: ['request-document-signature'],
    mutationFn: requestDocumentSignature,
  });
